import React from "react";
import RegisterPage, { STATUS_BADGES, PRIORITY_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";
import { apiFetch } from "../lib/api";

export default function StrategicRisks() {
  const { data, siteNames } = useHSE();
  const rows = data.strategicRisks || [];

  const handleSaveRecord = async (editingRecord) => {
    try {
      const res = await apiFetch("/strategic-risks", {
        method: "POST",
        body: {
          ...editingRecord,
          idempotencyKey: `rsk-${editingRecord.id}`,
        },
      });
      return res?.item ? { ...editingRecord, ...res.item } : editingRecord;
    } catch (err) {
      return editingRecord;
    }
  };

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <StatCard label="Total Strategic Items" value={rows.length} testid="rsk-total" />
      <StatCard label="Risks" value={rows.filter((r) => r.itemType !== "opportunity").length} tone="critical" />
      <StatCard label="Opportunities" value={rows.filter((r) => r.itemType === "opportunity").length} tone="safe" />
      <StatCard label="High/Critical Inherent" value={rows.filter((r) => (r.inherentScore || 0) >= 15).length} tone="warning" />
    </div>
  );

  return (
    <RegisterPage
      title="Strategic HSE Risks & Opportunities"
      subtitle="ISO 45001 Clause 6.1 — High-Level Risk & Opportunity Assessment with Authoritative Risk Matrix Scoring"
      storeKey="strategicRisks"
      idPrefix="RSK"
      topPanels={Top}
      onSaveRecord={handleSaveRecord}
      columns={[
        { key: "id", label: "ID" },
        { key: "itemType", label: "Type", render: (r) => <span className={`uppercase text-[10px] font-bold px-2 py-0.5 rounded ${r.itemType === "opportunity" ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}`}>{r.itemType || "Risk"}</span> },
        { key: "source", label: "Source" },
        { key: "title", label: "Title" },
        { key: "inherentScore", label: "Inherent Score", render: (r) => <span className="font-mono font-bold">{r.inherentScore || (Number(r.likelihood || 3) * Number(r.consequence || 3))}</span> },
        { key: "residualScore", label: "Residual Score", render: (r) => <span className="font-mono font-bold text-[#18B84F]">{r.residualScore || (Number(r.residualLikelihood || 2) * Number(r.residualConsequence || 2))}</span> },
        { key: "actionId", label: "Linked Action", render: (r) => r.actionId ? <span className="font-mono text-[11px] text-[#18B84F]">{r.actionId}</span> : <span className="text-slate-300">—</span> },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ status: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "Record ID" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "itemType", label: "Type", type: "select", options: ["risk", "opportunity"] },
        { key: "source", label: "Source", type: "select", options: ["Context Review", "Audit", "Incident RCA", "Regulatory Change", "Management Review"] },
        { key: "title", label: "Title" },
        { key: "description", label: "Description", type: "textarea", full: true },
        { key: "likelihood", label: "Inherent Likelihood (1-5)", type: "number" },
        { key: "consequence", label: "Inherent Consequence (1-5)", type: "number" },
        { key: "existingControls", label: "Existing Controls", type: "textarea", full: true },
        { key: "residualLikelihood", label: "Residual Likelihood (1-5)", type: "number" },
        { key: "residualConsequence", label: "Residual Consequence (1-5)", type: "number" },
        { key: "ownerUserId", label: "Owner" },
        { key: "reviewDate", label: "Review Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["open", "controlled", "monitored", "closed"] },
      ]}
    />
  );
}
